import { HttpErrorResponse } from '@angular/common/http';

export function extractErrorMessage(error: HttpErrorResponse): string {
  if (!error) {
    return 'An unknown error occurred';
  }

  if (!error.error) {
    return error.message || 'A server error occurred';
  }

  if (typeof error.error === 'string') {
    return error.error;
  }

  if (typeof error.error === 'object' && error.error.message) {
    return error.error.message;
  }

  return error.message || 'An unexpected error occurred';
}